import { render, staticRenderFns } from "./CamStreamsTabMob.vue?vue&type=template&id=00af8489&scoped=true"
import script from "./CamStreamsTabMob.vue?vue&type=script&lang=js"
export * from "./CamStreamsTabMob.vue?vue&type=script&lang=js"
import style0 from "./CamStreamsTabMob.vue?vue&type=style&index=0&id=00af8489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af8489",
  null
  
)

export default component.exports